import React, { useContext, useState, useEffect } from "react";
import { Row, Col } from "react-bootstrap";
import { Plus, Edit2, Trash2, Shield, Mail } from "lucide-react";
import AdminLayout from "../../../../layouts/admin/AdminLayout";
import "../../../../assets/css/admin/dashboardcss/SubAdmin.css";
import AppContext from "../../../../context/AppContext";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { checkLoggedInAdmin } from "../../../../helper/CustomHelper";

export default function SubAdmins() {
  const { baseUrl } = useContext(AppContext);
  const navigate = useNavigate();
  const [Name, setName] = useState("");
  const [Email, setEmail] = useState("");
  const [Password, setPassword] = useState("");
  const [Role, setRole] = useState("");
  const [Status, setStatus] = useState("");

  // ✅ Error states for validation
  const [errors, setErrors] = useState({
    name: "",
    email: "",
    password: "",
  });

  const [sgcSubAdmins, setSgcSubAdmins] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [deletingId, setDeletingId] = useState(null);
  const [sgcShowAdd, setSgcShowAdd] = useState(false);
  const [sgcShowEdit, setSgcShowEdit] = useState(false);
  const [sgcEditData, setSgcEditData] = useState({});

  const viewAllSubAdmin = () => {
    axios
      .get(`${baseUrl}/admin/subAdmin/viewAllSubAdmin`)
      .then((res) => setSgcSubAdmins(res.data))
      .catch((err) => console.log(err));
  };

  useEffect(() => {
    checkLoggedInAdmin(navigate);
    viewAllSubAdmin();
  }, []);

  // ✅ Validation function (Create ke liye — password required)
  const validateForm = () => {
    const nameError =
      Name.trim().length < 2 ? "Name must be at least 2 characters" : "";

    const emailError =
      !Email.trim() || !Email.includes("@") || !Email.includes(".")
        ? "Enter a valid email address"
        : "";

    const passwordError =
      Password.trim().length < 6
        ? "Password must be at least 6 characters"
        : "";

    setErrors({
      name: nameError,
      email: emailError,
      password: passwordError,
    });

    return !nameError && !emailError && !passwordError;
  };

  // ✅ Validation function (Edit ke liye — password optional, agar blank hai to skip)
  const validateEditForm = () => {
    const nameError =
      Name.trim().length < 2 ? "Name must be at least 2 characters" : "";

    const emailError =
      !Email.trim() || !Email.includes("@") || !Email.includes(".")
        ? "Enter a valid email address"
        : "";

    const passwordError = Password
      ? Password.trim().length < 6
        ? "Password must be at least 6 characters"
        : ""
      : "";

    setErrors({
      name: nameError,
      email: emailError,
      password: passwordError,
    });

    return !nameError && !emailError && !passwordError;
  };

  const createSubAdmin = () => {
    if (!validateForm()) {
      return;
    }

    setIsLoading(true);

    const formData = new FormData();
    formData.append("name", Name);
    formData.append("email", Email);
    formData.append("password", Password);
    formData.append("role", Role);
    formData.append("status", Status);

    axios
      .post(`${baseUrl}/admin/subAdmin/createSubAdmin`, formData)
      .then(() => {
        viewAllSubAdmin();
        setSgcShowAdd(false);

        setName("");
        setEmail("");
        setPassword("");
        setRole("");
        setStatus("");
        setErrors({ name: "", email: "", password: "" });
      })
      .catch((err) => console.log(err))
      .finally(() => setIsLoading(false));
  };

  const updateSubAdmin = () => {
    if (!validateEditForm()) {
      return;
    }

    setIsLoading(true);

    const formData = new FormData();
    formData.append("id", sgcEditData.id);
    formData.append("name", Name);
    formData.append("email", Email);
    formData.append("password", Password);
    formData.append("role", Role);
    formData.append("status", Status);

    axios
      .post(`${baseUrl}/admin/subAdmin/updateSubAdmin`, formData)
      .then(() => {
        viewAllSubAdmin();
        setSgcShowEdit(false);

        setName("");
        setEmail("");
        setPassword("");
        setRole("");
        setStatus("");
        setErrors({ name: "", email: "", password: "" });
      })
      .catch((err) => console.log(err))
      .finally(() => setIsLoading(false));
  };

  const sgcOpenEdit = (admin) => {
    setSgcEditData(admin);

    setName(admin.name);
    setEmail(admin.email);
    setPassword("");
    setRole(admin.isSuperAdmin == 0 ? "Admin" : "Sub Admin");
    setStatus(admin.status);
    setErrors({ name: "", email: "", password: "" });

    setSgcShowEdit(true);
  };

  const deleteSubAdmin = (id) => {
    setDeletingId(id);

    axios
      .delete(`${baseUrl}/admin/subAdmin/deleteSubAdmin/${id}`)
      .then((response) => {
        console.log(response.data);
        viewAllSubAdmin();
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        setDeletingId(null);
      });
  };

  const enabledCount = sgcSubAdmins.filter(
    (a) => a.status === "ENABLED",
  ).length;

  const disabledCount = sgcSubAdmins.filter(
    (a) => a.status === "DISABLED",
  ).length;

  return (
    <AdminLayout>
      <div className="sgc-sa-wrapper">
        <div className="sgc-sa-page-header">
          <div>
            <h1 className="sgc-sa-page-title">Sub Admins</h1>
            <p className="sgc-sa-page-sub">
              Manage your clinic team members and their roles.
            </p>
          </div>

          <button
            className="sgc-sa-add-btn"
            onClick={() => {
              setErrors({ name: "", email: "", password: "" });
              setSgcShowAdd(true);
            }}
          >
            <Plus size={16} /> Create Sub Admin
          </button>
        </div>

        <div className="sgc-sa-stats-strip">
          <div className="sgc-sa-stat">
            <span className="sgc-sa-stat-value">{sgcSubAdmins.length}</span>
            <span className="sgc-sa-stat-label">Total Members</span>
          </div>

          <div className="sgc-sa-stat-divider" />

          <div className="sgc-sa-stat">
            <span className="sgc-sa-stat-value sgc-sa-stat-value--green">
              {enabledCount}
            </span>
            <span className="sgc-sa-stat-label">Enabled</span>
          </div>

          <div className="sgc-sa-stat-divider" />

          <div className="sgc-sa-stat">
            <span className="sgc-sa-stat-value sgc-sa-stat-value--muted">
              {disabledCount}
            </span>
            <span className="sgc-sa-stat-label">Disabled</span>
          </div>
        </div>

        <Row className="g-4">
          {sgcSubAdmins.map((admin) => {
            const roleLabel = admin.isSuperAdmin == 0 ? "Admin" : "Sub Admin";
            const isDeletingThis = deletingId === admin.id;

            return (
              <Col key={admin.id} xs={12} sm={6} xl={4}>
                <div className="sgc-sa-card">
                  <span
                    className={`sgc-sa-status-dot ${
                      admin.status === "ENABLED"
                        ? "sgc-sa-status-dot--active"
                        : "sgc-sa-status-dot--inactive"
                    }`}
                  />

                  <div className="sgc-sa-card-top">
                    <div className="sgc-sa-avatar">
                      {admin.name?.charAt(0).toUpperCase()}
                    </div>

                    <div className="sgc-sa-card-info">
                      <h3 className="sgc-sa-card-name">{admin.name}</h3>

                      <span className="sgc-sa-role-badge">
                        <Shield size={11} /> {roleLabel}
                      </span>
                    </div>
                  </div>

                  <div className="sgc-sa-card-meta">
                    <span className="sgc-sa-meta-item">
                      <Mail size={13} /> {admin.email}
                    </span>
                  </div>

                  <div className="sgc-sa-card-actions">
                    <button
                      className="sgc-sa-btn-edit"
                      onClick={() => sgcOpenEdit(admin)}
                      disabled={isDeletingThis}
                    >
                      <Edit2 size={14} /> Edit
                    </button>

                    <button
                      className="sgc-sa-btn-delete"
                      onClick={() => deleteSubAdmin(admin.id)}
                      disabled={isDeletingThis}
                    >
                      {isDeletingThis ? "..." : <Trash2 size={14} />}
                    </button>
                  </div>
                </div>
              </Col>
            );
          })}
        </Row>

        {sgcShowAdd && (
          <div
            className="sgc-sa-modal-overlay"
            onClick={() => !isLoading && setSgcShowAdd(false)}
          >
            <div
              className="sgc-sa-modal-box"
              onClick={(e) => e.stopPropagation()}
            >
              <div className="sgc-sa-modal-header">
                <h5 className="sgc-sa-modal-title">Create Sub Admin</h5>

                <button
                  className="sgc-sa-modal-close"
                  onClick={() => setSgcShowAdd(false)}
                  disabled={isLoading}
                >
                  ×
                </button>
              </div>

              <div className="sgc-sa-modal-body">
                <div className="sgc-sa-form-group">
                  <label>Name</label>
                  <input
                    type="text"
                    value={Name}
                    onChange={(e) => setName(e.target.value)}
                    disabled={isLoading}
                  />
                  {errors.name && (
                    <small style={{ color: "red" }}>{errors.name}</small>
                  )}
                </div>

                <div className="sgc-sa-form-group">
                  <label>Email</label>
                  <input
                    type="email"
                    value={Email}
                    onChange={(e) => setEmail(e.target.value)}
                    disabled={isLoading}
                  />
                  {errors.email && (
                    <small style={{ color: "red" }}>{errors.email}</small>
                  )}
                </div>

                <div className="sgc-sa-form-group">
                  <label>Password</label>
                  <input
                    type="password"
                    value={Password}
                    onChange={(e) => setPassword(e.target.value)}
                    disabled={isLoading}
                  />
                  {errors.password && (
                    <small style={{ color: "red" }}>{errors.password}</small>
                  )}
                </div>

                <div className="sgc-sa-form-group">
                  <label>Role</label>
                  <select
                    value={Role}
                    onChange={(e) => setRole(e.target.value)}
                    disabled={isLoading}
                  >
                    <option value="Sub Admin">Sub Admin</option>
                    <option value="Moderator">Moderator</option>
                  </select>
                </div>

                <div className="sgc-sa-form-group">
                  <label>Status</label>
                  <select
                    value={Status}
                    onChange={(e) => setStatus(e.target.value)}
                    disabled={isLoading}
                  >
                    <option value="ENABLED">Enabled</option>
                    <option value="DISABLED">Disabled</option>
                  </select>
                </div>

                <button onClick={createSubAdmin} disabled={isLoading}>
                  {isLoading ? "Creating..." : "Create"}
                </button>
              </div>
            </div>
          </div>
        )}

        {sgcShowEdit && (
          <div
            className="sgc-sa-modal-overlay"
            onClick={() => !isLoading && setSgcShowEdit(false)}
          >
            <div
              className="sgc-sa-modal-box"
              onClick={(e) => e.stopPropagation()}
            >
              <div className="sgc-sa-modal-header">
                <h5 className="sgc-sa-modal-title">Edit Sub Admin</h5>

                <button
                  className="sgc-sa-modal-close"
                  onClick={() => setSgcShowEdit(false)}
                  disabled={isLoading}
                >
                  ×
                </button>
              </div>

              <div className="sgc-sa-modal-body">
                <div className="sgc-sa-form-group">
                  <label>Name</label>
                  <input
                    type="text"
                    value={Name}
                    onChange={(e) => setName(e.target.value)}
                    disabled={isLoading}
                  />
                  {errors.name && (
                    <small style={{ color: "red" }}>{errors.name}</small>
                  )}
                </div>

                <div className="sgc-sa-form-group">
                  <label>Email</label>
                  <input
                    type="email"
                    value={Email}
                    onChange={(e) => setEmail(e.target.value)}
                    disabled={isLoading}
                  />
                  {errors.email && (
                    <small style={{ color: "red" }}>{errors.email}</small>
                  )}
                </div>

                <div className="sgc-sa-form-group">
                  <label>Password (leave blank to keep unchanged)</label>
                  <input
                    type="password"
                    value={Password}
                    onChange={(e) => setPassword(e.target.value)}
                    disabled={isLoading}
                  />
                  {errors.password && (
                    <small style={{ color: "red" }}>{errors.password}</small>
                  )}
                </div>

                <div className="sgc-sa-form-group">
                  <label>Role</label>
                  <select
                    value={Role}
                    onChange={(e) => setRole(e.target.value)}
                    disabled={isLoading}
                  >
                    <option value="Sub Admin">Sub Admin</option>
                    <option value="Moderator">Moderator</option>
                  </select>
                </div>

                <div className="sgc-sa-form-group">
                  <label>Status</label>
                  <select
                    value={Status}
                    onChange={(e) => setStatus(e.target.value)}
                    disabled={isLoading}
                  >
                    <option value="ENABLED">Enabled</option>
                    <option value="DISABLED">Disabled</option>
                  </select>
                </div>

                <button onClick={updateSubAdmin} disabled={isLoading}>
                  {isLoading ? "Updating..." : "Update"}
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </AdminLayout>
  );
}
